var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui-button circle-button remove-button delete-button",
    width: "100%",
    height: "100%",
    viewBox: "0 0 125 125",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "interior-background",
    cx: 62.5,
    cy: 62.475,
    r: 62.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.769,35.959l-11.786,11.785l41.248,41.248l11.786,-11.785l-41.248,-41.248Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.983,77.207l11.786,11.785l41.248,-41.248l-11.786,-11.785l-41.248,41.248Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,-0.025c34.495,0 62.5,28.006 62.5,62.5c-0,34.495 -28.005,62.5 -62.5,62.5c-34.495,0 -62.5,-28.005 -62.5,-62.5c-0,-34.494 28.005,-62.5 62.5,-62.5Zm-0,16.667c25.296,0 45.833,20.537 45.833,45.833c0,25.297 -20.537,45.834 -45.833,45.834c-25.296,-0 -45.833,-20.537 -45.833,-45.834c-0,-25.296 20.537,-45.833 45.833,-45.833Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCancel);
export default __webpack_public_path__ + "static/media/button-cancel.6f650ab3.svg";
export { ForwardRef as ReactComponent };